<template>
    <v-select   :value="value" 
                @input="$emit('input', $event)"
                :options="sports"
                :multiple="multiple"
                :filter="vSelectSearch"
                class="hg-select sports" 
                :reduce="s => s.value"
                :disabled="!Array.isArray(sports)"
                required>
        <template slot="selected-option" slot-scope="option">
            <span class="text" v-i18n="option.text" />
        </template>
        <template slot="option" slot-scope="option">
            <span   class="text" v-i18n="option.text" />
        </template>
    </v-select>
</template>
<script>
export default {
    props:["value", "multiple"],
    data(){
        var self = this;
        return {
            sports: this.$hisport.getEnumAsDictionary(this.$hisport.options.enums.SPORT_TYPES).map(function(x){
                return {
                    value: x.id,
                    text: self.$hisport.i18n(x.label)
                }
            }),
        }
    },
    methods:{
        vSelectSearch(options, search){
            return search.length?options.filter(function(x){
                return x && x.text && x.text.toLowerCase().indexOf(search.toLowerCase())>=0
            }):options;
        }
    }
}
</script>
